
export default class Locale {

    static getString( state, key, replaceOptions ) {

        const locale = state.userData.locale && ( state.userData.locale.code || state.userData.locale.locale );

        if ( !state.clientData.bundleList[ locale ] ) {
            return `Missing locale value (${key})`;
        }

        const value = state.clientData.bundleList[ locale ].properties[ key ] || `Missing locale value (${key})`;

        if ( replaceOptions ) {
            return value.template( replaceOptions );
        }

        return value;
    }

    static updateLang( locale, dir ) {
        if ( document.documentElement.lang !== locale ) {
            document.documentElement.dir = dir || 'ltr';
            document.documentElement.lang = locale;
        }
    }
}
